/*
 * Copyright (c) 2018 Bruce Schubert.
 * The MIT License
 * http://www.opensource.org/licenses/mit-license
 */
import React from 'react';
import PropTypes from 'prop-types';
import Globe from '../globe';
import {Button} from 'reactstrap';
import SearchPreview from './SearchPreview';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSearchLocation} from "@fortawesome/free-solid-svg-icons";

/* global WorldWind */

const DEFAULT_ALTITUDE = 10000;

export default class SearchBox extends React.Component {

    static propTypes = {
      globe: PropTypes.instanceOf(Globe),
      mapQuestApiKey: PropTypes.string
    };

    constructor(props) {
      super(props);

      this.state = {
          modalOpen: false
      };

      this.handleClick = this.handleClick.bind(this);
      this.hideModal = this.hideModal.bind(this);
      this.goToSelection = this.goToSelection.bind(this)
    }

    handleClick(event) {
        event.preventDefault();
        this.setState({modalOpen: true});
    }

    hideModal() {
        this.setState({modalOpen: false});
    }

    goToSelection(selection) {
      if (selection) {
        const latitude = parseFloat(selection.lat);
        const longitude = parseFloat(selection.lon);

        // Update the globe
        this.props.globe.goTo(latitude, longitude, DEFAULT_ALTITUDE);
        this.hideModal();
      }
    }

    render() {
      return (
          <form className="form-inline" onSubmit={this.handleSubmit}>
              <Button color="success" onClick={this.handleClick}>
                  <FontAwesomeIcon icon={faSearchLocation} />
              </Button>
              <SearchPreview
                  isOpen={this.state.modalOpen}
                  handleHideModal={this.hideModal}
                  handleGotoSelection={this.goToSelection}
                  mapQuestApiKey={this.props.mapQuestApiKey}/>
          </form>
      );
    }
};
